import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton, Stack, TextField, Tooltip } from "@mui/material";

const MOBILE_PRODUCTION_INFO =
  "Los empleados activos asignados a las áreas Cocina o Barra pueden registrar desde la aplicación móvil producciones de elaborados correspondientes a su sector.";

function DateFilter({ label, value, onChange }) {
  return (
    <TextField
      type="date"
      label={label}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      size="small"
      InputLabelProps={{ shrink: true }}
      inputProps={{ "aria-label": `Fecha ${label.toLowerCase()}` }}
      sx={{
        width: { xs: "100%", sm: 165 },
        "& .MuiOutlinedInput-root": {
          height: 38,
          borderRadius: "33px",
          bgcolor: "neutral.100",
          color: "primary.900",
          fontSize: 13,
          fontWeight: 700,
          boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
          "& fieldset": { borderColor: "transparent" },
          "&:hover fieldset": { borderColor: "transparent" },
          "&.Mui-focused fieldset": { borderColor: "secondary.500" },
        },
        "& .MuiInputLabel-root": {
          color: "primary.900",
          fontSize: 12,
          fontWeight: 700,
        },
      }}
    />
  );
}

export default function ProductionFilters({ dateFrom, dateTo, onChange }) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1.5}
      sx={{ alignItems: { xs: "stretch", sm: "center" } }}
    >
      <DateFilter
        label="Desde"
        value={dateFrom}
        onChange={(value) => onChange("dateFrom", value)}
      />
      <DateFilter
        label="Hasta"
        value={dateTo}
        onChange={(value) => onChange("dateTo", value)}
      />
      <Tooltip title={MOBILE_PRODUCTION_INFO} arrow placement="top">
        <IconButton
          type="button"
          aria-label="Información sobre producción desde la aplicación móvil"
          sx={{
            alignSelf: { xs: "flex-start", sm: "center" },
            width: 36,
            height: 36,
            bgcolor: "primary.100",
            color: "primary.700",
            boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
            "&:hover": { bgcolor: "primary.200" },
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 21 }} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
